import React from 'react'
import { Link } from 'react-router-dom'

function AdminLinkCard({text,url}) {
  return (
    <Link className='primary-palette p-4 rounded heading flex-row-start items-center justify-center min-h-[12rem] hover:scale-105 transition-all hover:shadow-md' to={url}>{text}</Link>
  )
}

export default AdminLinkCard